module.exports = new __parcel__URL__("automation.ca873ee6.svg").toString();